<template>
	<ul class="margin-0 padding-left-normal padding-right-normal">
		<li
			v-for="tab in tabs"
			:key="tab.url"
			class="padding-top-big padding-bottom-big font-size-big border-bottom border-white-darker-4"
			:class="{'ink-base semi-bold': tab.selected, 'ink-lighter-1': !tab.selected}"
			@click="select(tab)"
			>
				<b-router-link 
					v-if="tab.url"
					routerLinkClasses="no-decoration"
					:to="tab.url"
				>
					{{ tab.title }}
				</b-router-link>
				<span 
					v-else
					@click="$emit('tabAction', tab.action)"
				>
					{{ tab.title }}	
				</span>
		</li>
	</ul>
</template>

<script>
import BRouterLink from './RouterLink.vue';

export default {
	name: 'b-nav-mobile-tabs',
	components: {
		BRouterLink
	},
	props: {
		tabs: {
			type: Array,
			required: true
		}
	},
	methods: {	
		select(currentTab) {
			this.$emit('handleSwitchMenu')
			this.$emit('activeTab', currentTab)
		}
	},
};
</script>
<docs>
    ```js
    <b-nav-mobile-tabs tabs="[
				{
					title: 'Meu Perfil',
					url: '#'
				},
				{
					title: 'Habilidades',
					url: '#'
				},
				{
					title: 'Vagas',
					url: '#'
				},
				{
					title: 'Projetos',
					url: '#'
				}
				{
					title: 'Sair',
					action: 'signOut',

				}
			]"
			@activeTab="methodToChangeSelectedTab"
			@handleSwitchMenu="methodToToggleMenu"
			@tabAction="handleTabAction"
		/>
    ```
</docs>
